import React from 'react';
import {
	Route,
	Routes
} from "react-router-dom";
/*Owner*/
import Master from './Screens/Master/index';
import Login from './Screens/Owners/Login/index';
import ShowFiles from './Screens/Owners/ShowFiles/index';
import FileNumberList from './Screens/Owners/FileNumberList/index';
import Home from './Screens/Owners/Home/index';
import BasePage from './Base/BasePage';

import LoginBySSO from './Screens/LoginBySSO/index';
import GetReportInfo from './Screens/GetReportInfo/index';

import ReturnFromIPG from './Screens/Owners/ReturnFromIPG/index';
import ReturnFromIPGUrbanizatio from './Screens/Owners/ReturnFromIPGUrbanizatio/index';
import ShowReviewDetail from './Screens/Owners/ShowReviewDetail/index';
import SubmitRequest from './Screens/Owners/SubmitRequest/index';
import RequestsReview from './Screens/Owners/RequestsReview/index';
import ShowModernizationToll from './Screens/Owners/ShowModernizationToll/index';
import CityFishView from './Screens/Owners/CityFishView/index';
import OrdersMapView from './Screens/Owners/OrdersMapView/index';
import TaxReview from './Screens/Owners/TaxReview/index';
import LettersView from './Screens/Owners/LettersView/index';
import ConstView from './Screens/Owners/ConstView/index';
import CertificateView from './Screens/Owners/CertificateView/index';
import Committee100Tax from './Screens/Owners/Committee100Tax/index';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
/*Owner*/

/*Trade*/
import BasePageTrade from './Base/BasePageTrade';
import LoginTrade from './Screens/Trade/Login/index';
import HomeTrade from './Screens/Trade/Home/index';
import ReturnFromIPGTrade from './Screens/Trade/ReturnFromIPG/index';
import ShowBusinessToll from './Screens/Trade/ShowBusinessToll/index';
/*Trade*/

/*Modernization*/
import BasePageModernization from './Base/BasePageModernization';
import LoginModernization from './Screens/Modernization/Login/index';
import HomeModernization from './Screens/Modernization/Home/index';
import ReturnFromIPGModernization from './Screens/Modernization/ReturnFromIPG/index';
import ShowModernization from './Screens/Modernization/ShowModernization/index';
/*Modernization*/

/*Refuse*/
import BasePageRefuse from './Base/BasePageRefuse';
import LoginRefuse from './Screens/Refuse/Login/index';
import HomeRefuse from './Screens/Refuse/Home/index';
import ReturnFromIPGRefuse from './Screens/Refuse/ReturnFromIPG/index';
import ShowRefuse from './Screens/Refuse/ShowRefuse/index';
/*Refuse*/

/*Employee​*/
import BasePageEmployee from './Base/BasePageEmployee';
import LoginEmployee from './Screens/Employee/Login/index';
import HomeEmployee from './Screens/Employee/Home/index';
import ReturnFromIPGEmployee from './Screens/Employee/ReturnFromIPG/index';
import CertificateLicenseReport from './Screens/Employee/CertificateLicenseReport/index';
import PermitReport from './Screens/Employee/PermitReport/index';
import FileSearch from './Screens/Employee/FileSearch/index';
import MayorApprovals from './Screens/Employee/MayorApprovals/index';
import MayorDeputyAprovals from './Screens/Employee/MayorDeputyAprovals/index';
import AssetsReport from './Screens/Employee/AssetsReport/index';
import RegionAssetsReport from './Screens/Employee/RegionAssetsReport/index';
import ResponsibleApprovals from './Screens/Employee/ResponsibleApprovals/index';
import YearAssetsReport from './Screens/Employee/YearAssetsReport/index';
import ShowReviewDetailEmployee from './Screens/Employee/ShowReviewDetail/index';
import ShowReviewListEmployee from './Screens/Employee/ShowReviewList/index';

import EmployeeCertificateView from './Screens/Employee/CertificateView/index';
import EmployeeConstView from './Screens/Employee/ConstView/index';
import EmployeeLettersView from './Screens/Employee/LettersView/index';
import EmployeeRequests from './Screens/Employee/Requests/index';
import EmployeeRequestsReview from './Screens/Employee/RequestsReview/index';
import EmployeeSubmitRequest from './Screens/Employee/SubmitRequest/index';

import FilingReview from './Screens/Employee/Requests/FilingReview/index';
import OwnerReview from './Screens/Employee/Requests/OwnerReview/index';
import ReviewApplication from './Screens/Employee/Requests/ReviewApplication/index';
import ReviewVisitReports from './Screens/Employee/Requests/ReviewVisitReports/index';
import ProceedingsReview from './Screens/Employee/Requests/ProceedingsReview/index';
import ReviewDocuments from './Screens/Employee/Requests/ReviewDocuments/index';
import ReviewCorrespondence from './Screens/Employee/Requests/ReviewCorrespondence/index';
import DesignReview from './Screens/Employee/Requests/DesignReview/index';
import OrdersReviewMap from './Screens/Employee/Requests/OrdersReviewMap/index';
import ComplicationsReview from './Screens/Employee/Requests/ComplicationsReview/index';
import CertificateEffects from './Screens/Employee/Requests/CertificateEffects/index';
import OffencerView from './Screens/Employee/Requests/OffencerView/index';
import ReviewDraftPermit from './Screens/Employee/Requests/ReviewDraftPermit/index';
import DraftReview from './Screens/Employee/Requests/DraftReview/index';
import FinancialStatus from './Screens/Employee/Requests/FinancialStatus/index';
import ArchiveList from './Screens/Employee/ArchiveList/index';
/*Employee​*/

/*Engineer*/
import BasePageEngineer from './Base/BasePageEngineer';
import LoginEngineer from './Screens/Engineer/Login/index';
import HomeEngineer from './Screens/Engineer/Home/index';
import GetEngineerFileList from './Screens/Engineer/GetEngineerFileList/index';
import ShowReportsList from './Screens/Engineer/ShowReportsList/index';
import CreateEngineerReport from './Screens/Engineer/CreateEngineerReport/index';
/*Engineer*/

/*ValidateLetter*/
import ValidateLetter from './Screens/ValidateLetter/index';
/*ValidateLetter*/

/*QuickPayment*/
import QuickPayment from './Screens/QuickPayment/index';
import ReturnFromIPGQuickPayment from './Screens/QuickPayment/ReturnFromIPGQuickPayment';

/*QuickPayment*/



const App = () => {
	return (
		<>
			<Routes>
					/*Owner*/
				<Route path="/" element={<Master />} />
				<Route path="/Login" element={<Login />} />
				<Route path="/LoginBySSO" element={<LoginBySSO />} />
				<Route path="/ShowFiles" element={<ShowFiles />} />
				<Route path="/FileNumberList" element={<FileNumberList />} />

				<Route path="/" element={<BasePage />}>
					<Route path="/Home" element={<Home />} />
					<Route path="/ReturnFromIPG" element={<ReturnFromIPG />} />
					<Route path="/ReturnFromIPGUrbanizatio" element={<ReturnFromIPGUrbanizatio />} />
					<Route path="/ShowReviewDetail" element={<ShowReviewDetail />} />
					<Route path="/SubmitRequest" element={<SubmitRequest />} />
					<Route path="/RequestsReview" element={<RequestsReview />} />
					<Route path="/ShowModernizationToll" element={<ShowModernizationToll />} />
					<Route path="/CityFishView" element={<CityFishView />} />
					<Route path="/OrdersMapView" element={<OrdersMapView />} />
					<Route path="/TaxReview" element={<TaxReview />} />
					<Route path="/LettersView" element={<LettersView />} />
					<Route path="/ConstView" element={<ConstView />} />
					<Route path="/CertificateView" element={<CertificateView />} />
					<Route path="/Committee100Tax" element={<Committee100Tax />} />

				</Route>
					/*Owner*/

				/*Trade*/
				<Route path="/LoginTrade" element={<LoginTrade />} />
				<Route path="/" element={<BasePageTrade />}>
					<Route path="Trade/Home" element={<HomeTrade />} />
					<Route path="Trade/ReturnFromIPG" element={<ReturnFromIPGTrade />} />
					<Route path="Trade/ShowBusinessToll" element={<ShowBusinessToll />} />
				</Route>
					/*Trade*/

				/*Modernization*/
				<Route path="/LoginModernization" element={<LoginModernization />} />
				<Route path="/" element={<BasePageModernization />}>
					<Route path="Modernization/Home" element={<HomeModernization />} />
					<Route path="Modernization/ReturnFromIPG" element={<ReturnFromIPGModernization />} />
					<Route path="Modernization/ShowModernization" element={<ShowModernization />} />
				</Route>
					/*Modernization*/

				/*Refuse*/
				<Route path="/LoginRefuse" element={<LoginRefuse />} />
				<Route path="/" element={<BasePageRefuse />}>
					<Route path="Refuse/Home" element={<HomeRefuse />} />
					<Route path="Refuse/ReturnFromIPG" element={<ReturnFromIPGRefuse />} />
					<Route path="Refuse/ShowRefuse" element={<ShowRefuse />} />
				</Route>
					/*Refuse*/

				/*Employee​*/
				<Route path="/LoginEmployee" element={<LoginEmployee />} />
				<Route path="/" element={<BasePageEmployee />}>
					<Route path="Employee/Home" element={<HomeEmployee />} />
					<Route path="Employee/ReturnFromIPG" element={<ReturnFromIPGEmployee />} />
					<Route path="Employee/CertificateLicenseReport" element={<CertificateLicenseReport />} />
					<Route path="Employee/PermitReport" element={<PermitReport />} />
					<Route path="Employee/FileSearch" element={<FileSearch />} />
					<Route path="Employee/MayorApprovals" element={<MayorApprovals />} />
					<Route path="Employee/MayorDeputyAprovals" element={<MayorDeputyAprovals />} />
					<Route path="Employee/AssetsReport" element={<AssetsReport />} />
					<Route path="Employee/RegionAssetsReport" element={<RegionAssetsReport />} />
					<Route path="Employee/ResponsibleApprovals" element={<ResponsibleApprovals />} />
					<Route path="Employee/YearAssetsReport" element={<YearAssetsReport />} />
					<Route path="Employee/ShowReviewDetailEmployee" element={<ShowReviewDetailEmployee />} />
					<Route path="Employee/ShowReviewListEmployee" element={<ShowReviewListEmployee />} />

					<Route path="Employee/CertificateView" element={<EmployeeCertificateView />} />
					<Route path="Employee/ConstView" element={<EmployeeConstView />} />
					<Route path="Employee/LettersView" element={<EmployeeLettersView />} />
					<Route path="Employee/Requests" element={<EmployeeRequests />} />
					<Route path="Employee/RequestsReview" element={<EmployeeRequestsReview />} />
					<Route path="Employee/SubmitRequest" element={<EmployeeSubmitRequest />} />

					<Route path="Employee/Requests/FilingReview" element={<FilingReview />} />
					<Route path="Employee/Requests/OwnerReview" element={<OwnerReview />} />
					<Route path="Employee/Requests/ReviewApplication" element={<ReviewApplication />} />
					<Route path="Employee/Requests/ReviewVisitReports" element={<ReviewVisitReports />} />
					<Route path="Employee/Requests/ProceedingsReview" element={<ProceedingsReview />} />
					<Route path="Employee/Requests/ReviewDocuments" element={<ReviewDocuments />} />
					<Route path="Employee/Requests/ReviewCorrespondence" element={<ReviewCorrespondence />} />
					<Route path="Employee/Requests/DesignReview" element={<DesignReview />} />
					<Route path="Employee/Requests/OrdersReviewMap" element={<OrdersReviewMap />} />
					<Route path="Employee/Requests/ComplicationsReview" element={<ComplicationsReview />} />
					<Route path="Employee/Requests/CertificateEffects" element={<CertificateEffects />} />
					<Route path="Employee/Requests/OffencerView" element={<OffencerView />} />
					<Route path="Employee/Requests/ReviewDraftPermit" element={<ReviewDraftPermit />} />
					<Route path="Employee/Requests/DraftReview" element={<DraftReview />} />
					<Route path="Employee/Requests/FinancialStatus" element={<FinancialStatus />} />
					<Route path="Employee/ArchiveList" element={<ArchiveList />} />
				</Route>
					/*Employee​*/

				/*Engineer*/
				<Route path="/LoginEngineer" element={<LoginEngineer />} />
				<Route path="/" element={<BasePageEngineer />}>
					<Route path="Engineer/Home" element={<HomeEngineer />} />
					<Route path="Engineer/GetEngineerFileList" element={<GetEngineerFileList />} />
					<Route path="Engineer/ShowReportsList" element={<ShowReportsList />} />
					<Route path="Engineer/CreateEngineerReport" element={<CreateEngineerReport />} />
				</Route>
					/*Engineer*/

		

				/*General*/
				<Route path="/ValidateLetter" element={<ValidateLetter />} />
				<Route path="/GetReportInfo" element={<GetReportInfo />} />
				<Route path="/QuickPayment" element={<QuickPayment />} />
				<Route path="/QuickPayment/ReturnFromIPG/" element={<ReturnFromIPGQuickPayment />} />
				/*General*/

			</Routes>
			<ToastContainer
				position="top-center"
				autoClose={5000}
				rtl={true}
				hideProgressBar={false}
			/>
		</>
	);
};

export default App;
